import { Button, Divider, Header, Text, Checkbox } from '@wework/dieter-ui'
import { withFloorMap, withManager } from '@wework/react-floormap'
import _ from 'lodash'

import withFeatures from '../../hoc/withFeatures'
import compose from '../../utils/compose'

import React, { useEffect, useState } from 'react'
import Row from '../Common/Row'
import bookSpaceGlobally from '../../assets/icons/book-space-globally.png'
import measure from '../../assets/icons/measure.png'
import floor from '../../assets/icons/floor.png'
import capacity from '../../assets/icons/capacity.png'
import MetricDisplay from '../Common/MetricDisplay'
import Modal from '../Modal'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import { useSidebar } from '../../hoc/withSidebar'
import withEventEmitter from '../../hoc/withEventEmitter'
import CloseIcon from '../../assets/images/CloseIcon.svg'
import { SpaceIcon, ProductIcon, RightArrow } from '../Icons'
import IMTheme from '../../style/IMTheme'

function BuildingInfo({
  emitUserEvent,
  floorMap,
  handleToggle,
  manager,
  snackBars,
}) {
  const { closeSideBar, openSideBar } = useSidebar()
  const [loader, setLoader] = useState(false)
  const [modalData, setModalData] = useState<any>({ open: false })
  const [data, setData] = useState<any>([])
  const [floorData, setFloorData] = useState<
    | {
        url: string
        name: string
      }
    | undefined
  >()
  const { currentBuilding, currentFloor } = floorMap
  if (!currentBuilding) return <></>
  const buildingName = _.get(currentBuilding, 'name', 'undefined')
  // const buildingId = currentBuilding.systemUUID || currentBuilding.uuid || ''
  const addr1 = _.get(currentBuilding, 'addr1')
  const addr2 = _.get(currentBuilding, 'addr2')
  const combinedAddr = addr2 ? `${addr1} ${addr2}, ` : `${addr1}, `
  const buildingAddress = `${combinedAddr} ${_.get(
    currentBuilding,
    'city'
  )} ${_.get(currentBuilding, 'postalCode')}`
  const numOfFloors = _.get(currentBuilding, 'floors', []).length
  const numOfSpaces = _.get(currentFloor, 'total_rooms', 0)
  const numOfProducts = _.get(currentFloor, 'total_inventories', 0)
  const floorName = _.get(currentFloor, 'name')
  let numOfDesks = _.get(currentFloor, 'metrics.desks', 0)
  let rsf = _.get(currentFloor, 'metrics.rsf', 0)
  let sf = _.get(currentFloor, 'metrics.sf', 0)
  let usf = _.get(currentFloor, 'metrics.usf', 0)

  if (!numOfDesks) {
    numOfDesks = 0
  }

  const handleRefreshBuilding = async () => {
    const buildingUUID = _.get(currentBuilding, 'systemUUID', null)
    try {
      setLoader(true)
      await floorMap.extensions.classification.refreshCache(buildingUUID)

      try {
        await floorMap.render({
          buildingId: buildingUUID,
          floorId: currentFloor?.uuid,
          autoLoadFloor: false,
          skipCache: true,
        })
      } catch (e) {
        console.warn(e)
      }

      snackBars.addAlert({
        text: `Success!`,
        variant: 'success',
      })
    } catch (e) {
      console.error(e)
      snackBars.addAlert({
        text: `Ops! Something went wrong, please try again.`,
        variant: 'error',
      })
    }
    emitUserEvent('CLEAR_CACHE')
    setLoader(false)
    closeSideBar()
  }

  const showConfirm = () => {
    return (
      <Modal
        open={modalData.open}
        title={'Confirm Action'}
        content={modalData.content}
        confirmText={'YES'}
        cancelText={'NO'}
        onConfirm={modalData.onConfirm}
        onClose={() => setModalData({ ...modalData, open: false })}
      />
    )
  }

  return (
    <>
      {showConfirm()}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Row>
          <Header as="h3" style={{ margin: 0 }}>
            Info
          </Header>
          <Button
            basic
            onClick={() => closeSideBar()}
            icon={
              <div style={{ width: 18, height: 18 }}>
                <CloseIcon />
              </div>
            }
            style={{
              margin: 0,
            }}
          />
        </Row>
        <Text style={{ marginTop: 28 }} size="huge">
          {buildingName}
        </Text>
        <Text size="tiny">{buildingAddress}</Text>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={bookSpaceGlobally} />
          <Text
            style={{ marginLeft: 24, color: IMTheme.colors.darkGray }}
            size="small"
          >
            {_.get(currentBuilding, 'code')}
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={floor} />
          <Text style={{ marginLeft: 24 }} size="small">
            {numOfFloors} floors
          </Text>
        </Row>
        <Divider light style={{ margin: '24px 0px' }} />
        <Text>{floorName}</Text>
        <div
          style={{
            display: 'flex',
            marginTop: 20,
            justifyContent: 'space-between',
            cursor: 'pointer',
          }}
          onClick={() => openSideBar('BuildingInfoSpaces')}
        >
          <Row>
            <Row style={{ justifyContent: 'flex-start' }}>
              <SpaceIcon />
              <Text style={{ marginLeft: 27 }} size="small">
                {numOfSpaces} spaces
              </Text>
            </Row>
            <div style={{ marginRight: IMTheme.spacing[3] }}>
              <RightArrow style={{ marginRight: IMTheme.spacing[3] }} />
            </div>
          </Row>
        </div>
        <div
          style={{
            display: 'flex',
            marginTop: 20,
            justifyContent: 'space-between',
            cursor: 'pointer',
          }}
          onClick={() => openSideBar('BuildingInfoProducts')}
        >
          <Row style={{ justifyContent: 'flex-start' }}>
            <ProductIcon />
            <Text style={{ marginLeft: 24 }} size="small">
              {numOfProducts} inventory
            </Text>
          </Row>
          <div style={{ marginRight: IMTheme.spacing[3] }}>
            <RightArrow style={{ marginRight: IMTheme.spacing[3] }} />
          </div>
        </div>
        <Row
          style={{
            marginTop: 20,
            justifyContent: 'flex-start',
          }}
        >
          <img src={capacity} />
          <Text style={{ marginLeft: 24 }} size="small">
            {numOfDesks} seats
          </Text>
        </Row>
        <Row
          style={{
            marginTop: 20,
            justifyContent: 'flex-start',
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <img src={measure} style={{ width: 16, height: 16 }} />
          <Text
            style={{
              marginLeft: 24,
              whiteSpace: 'pre-wrap',
              lineHeight: '20px',
            }}
            size="small"
          >
            <MetricDisplay value={sf} /> {'\n'}
            <MetricDisplay value={usf} midFix="usable" />
            {'\n'}
            <MetricDisplay value={rsf} midFix="rentable" />
            {'\n'}
          </Text>
        </Row>
        <Divider light style={{ margin: '24px 0px' }} />
        <Text>Refresh data</Text>
        <Text size="tiny">
          Refresh building information and get any updates from the data
          sources.
        </Text>
        <Button
          onClick={async () => {
            setModalData({
              open: true,
              content: (
                <>
                  <span style={{ fontSize: 14, color: '#212121' }}>
                    Are you sure you want to clear the cache of this building?
                  </span>
                  <br />
                  <br />
                </>
              ),
              onConfirm: () => {
                handleRefreshBuilding()
              },
            })
          }}
          primary
          basic
          style={{ width: 81, marginTop: 16 }}
        >
          Refresh
        </Button>
      </div>
    </>
  )
}

export default compose(
  withFloorMap(),
  withFeatures(),
  withEventEmitter(),
  withManager()
)(withSnackbar(BuildingInfo))
